import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section max-w-3xl" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "ul-box" }
const _hoisted_4 = { class: "wrong" }
const _hoisted_5 = { class: "section" }
const _hoisted_6 = { class: "section lg:text-center" }

import ArticleModalContent from '@/components/ArticleModalContent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Parodontologija',
  emits: ["close", "navigate"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_circular_image = _resolveComponent("a-circular-image")!

  return (_openBlock(), _createBlock(ArticleModalContent, {
    title: _ctx.$t('articles.parodontologija.title'),
    cover: require('@/assets/covers/parodontalna.jpg'),
    "close-button-dark": true,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.parodontologija.intro1')), 1),
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.parodontologija.introWarning')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.parodontologija.intro2body')), 1)
        ])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.parodontologija.napredovanaTitle')), 1),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/parodontoza.jpg')
        }, null, 8, ["image"]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.parodontologija.napredovanaP1')), 1),
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.parodontologija.napredovanaP2Bold')), 1),
          _createTextVNode(". " + _toDisplayString(_ctx.$t('articles.parodontologija.napredovanaP2body')), 1)
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.parodontologija.napredovanaP3')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('articles.parodontologija.listTitle')), 1),
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('articles.parodontologija.listItem1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('articles.parodontologija.listItem2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('articles.parodontologija.listItem3')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('articles.parodontologija.listItem4')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('articles.parodontologija.listItem5')), 1)
          ])
        ])
      ]),
      _createVNode(_component_a_circular_image, {
        image: require('@/assets/photos/preventiva.jpg'),
        float: "right"
      }, null, 8, ["image"]),
      _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.parodontologija.kajLahkoTitle')), 1),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.parodontologija.kajLahkoPre')), 1),
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', 'ortopan')))
          }, _toDisplayString(_ctx.$t('articles.parodontologija.kajLahkoXray')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.parodontologija.kajLahkoPost')), 1)
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "clear-both" }, null, -1)),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.parodontologija.potekTitle')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.parodontologija.potekP1')), 1),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.parodontologija.potekP2pre')), 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.parodontologija.potekManual')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.parodontologija.potekP2post')), 1)
        ]),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('articles.parodontologija.laserTitle')), 1),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/laser-urska.jpg'),
          float: "right"
        }, null, 8, ["image"]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.parodontologija.laserP1pre')), 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.parodontologija.laserText')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.parodontologija.laserP1body')), 1)
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.parodontologija.laserP2')), 1)
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.parodontologija.cenikPre')), 1),
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('navigate', 'cenik', 'parodontologija')))
          }, _toDisplayString(_ctx.$t('articles.parodontologija.cenikLinkText')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.parodontologija.cenikPost')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "cover"]))
}
}

})